<template>
    <section class="lg:py-16 sm:py-8">
       <div class="mx-auto max-w-8xl">
           <div class="grid grid-cols-12 lg:px-4 gap-y-6">

            <div class="col-span-12 lg:col-span-5">
                   <nuxt-img :src="imageSrc" :alt="imageAlt" width="542" height="534"
                       sizes="xs:330px sm:440px md:760px lg:1023px xl:493px 2xl:989px" loading="lazy" format="webp"
                       class="mx-auto xl:-mr-16 2xl:mr-0" />
               </div>
   
               <div class="max-w-4xl col-span-12 px-6 pb-8 lg:col-span-7 2xl:px-32 md:px-16 lg:py-0 xl:pl-28">
                   <div class="flex flex-col justify-center h-full">
                       <h2 class="text-2xl font-bold text-center md:text-3xl lg:text-3xl xl:text-40 xl:leading-10 font-ww-bold md:text-left">
                           {{ heading }}
                       </h2>
                       <div class="lg:mt-8 mt-4  text-base !leading-5 md:text-lg font-ww-regular xl:pr-20 md:text-left text-center" v-html="description"></div>
                   </div>
               </div>
   
              
   
   
           </div>
       </div>
    </section>
   </template>
   
   <script setup>
   const props = defineProps({
       heading: {
           type: String,
           default: "White Chocolate Mocha"
       },
       description: {
           type: String,
           default: `
Sweet and sinful, decadent and rich, pure perfection. Our hand-selected, mountain-shade grown, perfectly processed and precisely roasted, premium specialty coffee beans combine with the rich flavor of velvety smooth, creamy white chocolate to overwhelm your senses. 
<br><br>

A combination of excellence and elegance, you breathe in the aromas of silky white chocolate and bold, rich coffee. You sip, you savor, you indulge. And now, you simply must come back for more…
         `
       },
       imageSrc: {
           type: String,
           default: "/assets/images/white-chocolate.png"
       },
       imageAlt: {
           type: String,
           default: "White Chocolate Mocha"
       }
   });
   
   defineBuilderComponent({
       friendlyName: "InfoWithLeftImage",
       inputs: [
           {
               name: "heading",
               type: "string",
               friendlyName: "Heading",
               defaultValue: "White Chocolate Mocha"
           },
           {
               name: "description",
               type: "richText",
               friendlyName: "Description",
               defaultValue: `
   Sweet and sinful, decadent and rich, pure perfection. Our hand-selected, mountain-shade grown, perfectly processed and precisely roasted, premium specialty coffee beans combine with the rich flavor of velvety smooth, creamy white chocolate to overwhelm your senses. 
<br><br>

A combination of excellence and elegance, you breathe in the aromas of silky white chocolate and bold, rich coffee. You sip, you savor, you indulge. And now, you simply must come back for more…
           `
           },
           {
               name: "imageSrc",
               type: "file",
               friendlyName: "Image Source",
               allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
               defaultValue: "/assets/images/white-chocolate.png"
           },
           {
               name: "imageAlt",
               type: "string",
               friendlyName: "Image Alt Text",
               defaultValue: "Chocolate Covered Strawberry"
           }
       ]
   });
   </script>